import * as React from 'react';

export default class extends React.Component {
  render() {
    return <li className="menu-divider">{this.props.children}</li>;
  }
}



// WEBPACK FOOTER //
// ./src/components/MenuDivider.tsx